export const messageLangs = {
    '1': 'he',
    '3': 'eng'
};
